import { render, staticRenderFns } from "./PopupShare.vue?vue&type=template&id=4ff3da1b"
import script from "./PopupShare.vue?vue&type=script&lang=js"
export * from "./PopupShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports